import type { ChipProps } from '@mui/material/Chip';
import Stack from '@mui/system/Stack';
import { MultipleNeutral2 } from '../../streamlineSolidIcon/MultipleNeutral2';
import { FilledChip } from '../FilledChip';

interface Props extends Omit<ChipProps, 'label' | 'icon'> {
  label?: string;
}

export const GroupChatChip = ({ label = 'Group chat', ...props }: Props) => {
  return (
    <FilledChip
      variant="filled"
      label={
        <Stack sx={{ flexDirection: 'row', alignItems: 'center', gap: 0.5 }}>
          {label}
          <MultipleNeutral2 size="small" color="textSecondary" />
        </Stack>
      }
      {...props}
    />
  );
};
